// Term copy lives in content/rates.json — shared with the backend prerender so the static HTML matches this page.
import RATES from "./content/rates.json";

export const TERM_META = RATES.terms;
export const SWITCH_META = RATES.switch;
